import { GridColumns } from 'shared/types';
import { AccountNumberParams } from 'pages/managePricing/managePricingResolver';
import { useParams } from 'react-router-dom';
import { ProductFilterEnum } from 'shared/constants';
import { createTableDataContext } from 'shared/providers/provideTableData';
import { TAddProductsData } from 'types/backend';
import { ProductsResolver } from './ProductsResolver';

interface ExclusiveProductsResolverProps {
    columnConfig: GridColumns<TAddProductsData>;
}

export const exclusiveProductsContext = createTableDataContext<TAddProductsData>();

export function ExclusiveProductsResolver({columnConfig}: ExclusiveProductsResolverProps) {
    const {accountNumber} = useParams<AccountNumberParams>();
    
    return (
        <ProductsResolver
            columnConfig={columnConfig}
            productsContext={exclusiveProductsContext}
            productTabSelected={ProductFilterEnum.EXCLUSIVE}
            name='ExclusiveProduct'
            alternateQueryPath={`subset/${accountNumber}`}
            title='Available Exclusive Products'
        />
    );
}
